
import store from "../store";
import { tokenExpirado, redirectLoginExpirado } from "../utils/jwt";
import { resolverBaseUrl, resolverUrl } from "../utils/conectividad";


const interceptorCaseRequest = (config = {}) => {
  // ─── Base URL según conectividad ─────────────────────────────────────
  // Se resuelve por request (no en axios.create) para que el swap online/offline
  // aplique cuando la conexión cambia con la app ya cargada.
  // http.js arma URLs relativas (usa baseURL) — axios crudo arma URLs absolutas,
  // donde baseURL se ignora, así que ahí hay que reescribir la url directamente.
  if (/^https?:\/\//i.test(config.url || "")) {
    config.url = resolverUrl(config.url);
  } else {
    config.baseURL = resolverBaseUrl();
  }

  // ─── Token expirado antes de la request ──────────────────────────────
  const esAuth = config.url?.includes("/auth/");
  const accessToken = localStorage.getItem("accessToken");
  if (!esAuth && accessToken && tokenExpirado()) {
    store.commit("logout");
    redirectLoginExpirado();
    return Promise.reject(new Error("Token expirado"));
  }

  // Read token per-call — never at module scope (avoids stale token after re-login)
  const raw = accessToken;
  const token = raw?.replace(/^"+|"+$/g, "").trim();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Tenant header — parsed from user object in localStorage
  const empresa =
    JSON.parse(localStorage.getItem("token") || "{}")?.empresa_cliente ||
    process.env.VUE_APP_EMPRESA;

  if (empresa && !config.url?.includes("/base/clientes/config")) {
    config.headers["X-Empresa-Cliente"] = empresa;
  }

  return config;
}

export default interceptorCaseRequest;